import { call, throttle, put } from 'redux-saga/effects';
import * as getFieldsActions from '../actions/getFieldsActions';
import {
  getModelsByBrandRequest,
  getModelsByBrandsKeysRequest,
} from '../../api/vehicles/getFieldsRequests';

function* getModelsByBrandSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getModelsByBrandRequest, payload);
    yield put(getFieldsActions.getModelsByBrandSuccess(response));
  } catch (error) {
    yield put(getFieldsActions.getModelsByBrandError(error));
  }
}

function* getModelsByBrandsKeysSaga(action) {
  if (action.payload && action.payload.length > 0) {
    try {
      const { payload } = action;
      const response = yield call(getModelsByBrandsKeysRequest, payload);
      yield put(getFieldsActions.getModelsByBrandsKeysSuccess(response));
    } catch (error) {
      yield put(getFieldsActions.getModelsByBrandsKeysError(error));
    }
  }
}

export function* getFieldsByIdWatcher() {
  yield throttle(
    0,
    getFieldsActions.getModelsByBrand.toString(),
    getModelsByBrandSaga
  );
  yield throttle(
    0,
    getFieldsActions.getModelsByBrandsKeys.toString(),
    getModelsByBrandsKeysSaga
  );
}
